import { IconButton, Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box, Button } from 'native-base';
import React from 'react';

import {
  TableContentItemBadge,
  TableContentItemCaptions,
} from '../../../../../../components/TableContent';
import { messageError } from '../../../../../NewApplication/utils';
import { mapCaptions } from '../../../../utils';
import { CustomerItemTagObject } from '../../../../utils/types';
import { ItemTag } from '../../../Customer/components/ItemTag';

import { RequiredAttentionResponsiveItem } from '.';

export const RequiredAttentionItemTablet: React.FC<RequiredAttentionResponsiveItem> = ({
  handleDetailsCustomer,
  detailsButtonIsDisabled,
  sectionIsOpened,
  toggleSection,
  item,
}) => {
  return (
    <Shadow borderRadius={BoxRadius.xs} level={2}>
      <VStack
        p={Spacing['inline.xxs']}
        space={Spacing['inline.xxs']}
        alignItems="center"
        borderRadius={BoxRadius.xs}>
        <HStack
          w={'full'}
          space={Spacing['inline.xxxs']}
          p={Spacing['inline.xxs']}
          borderRadius={BoxRadius.xs}
          alignItems="center"
          justifyContent="space-between">
          <HStack space={Spacing['inline.xs']} alignItems="center" justifyContent="space-between">
            <VStack>
              <Text noOfLines={1} fontSize={Typography['fontsize.md']} color="neutral.darkest">
                {item?.customer?.customerName || messageError}
              </Text>
              <HStack space={Spacing['inline.nano']} alignItems="center">
                <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                  Conta
                </Text>
                <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                  {item?.customer?.account?.accountNumber || messageError}
                </Text>
                <TableContentItemCaptions forceDesktop icons={mapCaptions(item?.customer)} />
              </HStack>
            </VStack>
            <HStack alignItems={'center'} space={Spacing['inline.xxxs']}>
              <TableContentItemBadge>Moderado</TableContentItemBadge>
              <ItemTag
                isListing
                data={(item?.customer?.hashtags as unknown as CustomerItemTagObject[]) || []}
                itemId={item?.customer?.customerId}
              />
            </HStack>
          </HStack>
          <Button
            variant="textLink"
            onPress={handleDetailsCustomer}
            isDisabled={detailsButtonIsDisabled}
            _text={{
              fontFamily: Typography['fontfamily.base.semibold'],
              color: detailsButtonIsDisabled ? 'neutral.darkest' : 'brand.tertiary.principal',
            }}>
            Ver Detalhes
          </Button>
        </HStack>
        {item?.errors && item?.errors.length > 0 && (
          <VStack
            borderRadius={BoxRadius.sm}
            backgroundColor={Utils.ColorToken.WithOpacity('background', 'opacity.semiopaque')}
            space={Spacing['stack.xxxs']}
            px={Spacing['inline.xxs']}
            w={'full'}
            py={Spacing['inline.xxxs']}>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
              <Text fontSize={Typography['fontsize.md']} color="neutral.darkest" variant="semibold">
                Itens que Requerem atenção
              </Text>
              <IconButton
                icon={sectionIsOpened ? 'ChevronUp' : 'ChevronDown'}
                testId="section-toggle"
                onPress={toggleSection}
                iconColor={Color['neutral.black']}
              />
            </HStack>
            {sectionIsOpened && (
              <VStack space={Spacing['inline.xxxs']}>
                <Box h="1px" w={'full'} bg={'neutral.lightest'} />
                {item.errors?.map((error) => (
                  <VStack key={error?.errorId} space={Spacing['inline.nano']}>
                    <Text
                      fontSize={Typography['fontsize.md']}
                      color="neutral.darkest"
                      variant="semibold">
                      {error?.errorTitle || messageError}
                    </Text>
                    <Text
                      fontSize={Typography['fontsize.md']}
                      color="neutral.darkest"
                      variant="regular">
                      {error?.errorMessage && error?.errorSuggest
                        ? `${error?.errorMessage} ${error?.errorSuggest}`
                        : messageError}
                    </Text>
                  </VStack>
                ))}
              </VStack>
            )}
          </VStack>
        )}
      </VStack>
    </Shadow>
  );
};
